import { render } from "./account-insert.vue?vue&type=template&id=d0b1d248&scoped=true"
import script from "./account-insert.vue?vue&type=script&lang=js"
export * from "./account-insert.vue?vue&type=script&lang=js"

import "./account-insert.vue?vue&type=style&index=0&id=d0b1d248&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b1d248"]])

export default __exports__